module.exports = __webpack_public_path__ + "img/haindling_kreuzaltar_2020_ref.021aa3e0.jpg";